'use client';

import { useEffect } from 'react';
import Link from 'next/link';
import { Home, RotateCcw } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <section className="bg-gradient-to-b from-primary-50 via-white to-white">
      <div className="container mx-auto flex max-w-xl flex-col items-center px-4 py-20 text-center sm:py-28">
        <span aria-hidden="true" className="mb-6 text-5xl">
          🙈
        </span>
        <h1 className="text-3xl font-semibold tracking-tight text-gray-900 sm:text-4xl">Something went wrong</h1>
        <p className="mt-4 text-base leading-relaxed text-gray-600">
          Sorry, this page didn&apos;t load properly. Your cards and messages are safe. Please try again in a moment.
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Button size="xl" shape="pill" onClick={() => reset()}>
            <RotateCcw aria-hidden="true" />
            Try again
          </Button>
          <Button asChild size="xl" shape="pill" variant="soft">
            <Link href="/">
              <Home aria-hidden="true" />
              Go to homepage
            </Link>
          </Button>
        </div>
        {error.digest && <p className="mt-6 text-xs text-gray-500">Reference: {error.digest}</p>}
      </div>
    </section>
  );
}
